import { axiosClient } from "../../api/api";

export const getUnclaimedStudies = async (panelistId: number) => {
  return axiosClient
    .get("/api/survey/getUnclaimedStudies", {
      params: { panelistId },
    })
    .then((response) => response.data);
};
